import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {convertUrlToNewSite} from '@/_application/core/utils/convert-url';
import {getSolidIconHighlightCategory} from '@/_application/modules/categories/utils/icon';
import {HighlightCategory} from '__generated__/__types__';

interface IProps {
    category: HighlightCategory;
}

const HighLightCategory: React.FC<IProps> = ({category}) => {
    const image = getSolidIconHighlightCategory(category);
    const backgroundColorOpacity = category?.background_app_icon ? category?.background_app_icon + '80' : '#eaeaea80'; // 80 is code for 50%
    return (
        <li>
            <Link
                href={convertUrlToNewSite(category?.url ?? '/')}
                className="flex w-[91px] cursor-pointer select-none flex-col items-center justify-start gap-3 transition-opacity hover:opacity-80">
                <div
                    className="flex h-[104px] w-[74px] items-center justify-center rounded-full"
                    style={{backgroundColor: backgroundColorOpacity}}>
                    <div className="relative h-[46px] w-[46px]">
                        <Image
                            src={image ?? ''}
                            alt={`${category?.name!} icon`}
                            fill
                            sizes="100%"
                            className="object-contain"
                        />
                    </div>
                </div>
                <p className="line-clamp-2 text-center text-base leading-[22px] text-KPZ_text_1st">{category?.name}</p>
            </Link>
        </li>
    );
};

export default HighLightCategory;
